const palette = {
    body       : "#2B3844",
    headerTop  : "#2B3844",
    header     : "#202C36",
    footer     : "#202C36",
    footerFont : "#c3c3c3",

    tableBody   : "#202C36",
    tableBack   : "#2B3844",
    tableLine  : "#444",
    tableText  : "#FFF",
    
    logout     : "#de3013",
    logoutFont : "#ffffff",

    loginBg : "#464545",
    fontMenu   : "#ffffff",
    fontHeader : "#ffffff",
    fontHover  : "#4AACEB",

    modalDeleteBtn : "#454545",
    modalBody       : "#202C36",
    modalText      : "#FFF",
    modalLabel      : "#131b20",

    tabCard : "#202C36",
    tabCardColor : "#FFF",
    tabHoverColor : "#4AACEB",
    tabSelectedColor : "#4AACEB",
    tabActiveColor : "#FFF",

    transferBg : "#434D56",
    transferBgDisabled : "#434D56",
    transferBorder : "#2B3844",

    buttonBg : "#2B3844",
    buttonBorder: "#CCC",
    buttonText : "#FFF",
    buttonPrimary : "#3b3b3b",

    radioSelected : "#4AACEB",
  };
  
  export default palette;